import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import LoadingSpinner from '../loading-spinner/LoadingSpinner';
import {RouteConstants} from "../route/services/RouteConstants";
import * as userActions from './ducks/actions';
import * as langActions from '../language/ducks/actions';
import auth from "../../services/auth/AuthProvider";

class AuthCallback extends Component {

    handleAuthentication = () => {
        // if (/access_token|id_token|error/.test(this.props.location.hash)) {
        auth.handleAuthentication().then(authResult => {
            if (auth.isRegularAuthentication(authResult)) {
                this.props.setLanguage(authResult.lang);
            }

            let userProfile = authResult.idTokenPayload;
            if (userProfile) {
                this.props.setUserProfile(userProfile);
                if (userProfile.userAccountId && localStorage.getItem('myb_heap_app_id') && window.heap) {
                    window.heap.identify(userProfile.userAccountId, 'uuid')
                }
                var route = sessionStorage.getItem("myblock_route");
                sessionStorage.removeItem("myblock_route");
                
                if (Boolean(route)) {
                    this.props.history.push(route)
                } else {
                    this.props.history.push(RouteConstants.DASHBOARD);
                }
            }
        }).catch(err => {
            console.log(err);
            this.props.history.push(RouteConstants.REDIRECTION_ERROR);
        });
    };

    componentDidMount() {
        this.handleAuthentication();
    }

    render() {
        return (
            <LoadingSpinner />
        );
    }
}

AuthCallback.propTypes = {
  setUserProfile: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  return {}
};

export default connect(
    mapStateToProps,
    {...userActions, ...langActions}
)(AuthCallback);